/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createAuth0 } from '@auth0/auth0-vue'
import { addCollection as addIconCollection } from '@iconify/vue'
import * as Sentry from '@sentry/vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { Formio } from 'formiojs'
import { createApp } from 'vue'
import Toast, { POSITION } from 'vue-toastification'

import '@metras/frontend-shared/assets/main.scss'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-toastification/dist/index.css'
import App from './App.vue'
import './assets/formio/bootstrap.min.scss'
import './assets/formio/formio.full.scss'
import router from './router'
import featherIcons from '@metras/frontend-shared/assets/feather-icons.json'

import { DirectoryIncrementNumberComponent } from '@app/utils/formio/directory-increment-number-component'
import { formioAuthPlugin } from '@app/utils/formio/formio-auth.plugin'

addIconCollection(featherIcons)

Formio.use({
  components: {
    directorySelect: DirectorySelectComponent,
    directoryEntrySelect: DirectoryEntrySelectComponent,
    directoryEntryMultiSelect: DirectoryEntryMultiSelectComponent,
    incrementNumber: DirectoryIncrementNumberComponent
  }
})
Formio.registerPlugin(formioAuthPlugin, 'metras-auth')

ModuleRegistry.registerModules([AllCommunityModule])

const apiRoot = import.meta.env.VITE_API_ROOT

if (apiRoot.includes('.dev.') || apiRoot.includes('.stage.') && !document.getElementById('ybug-button-script')) {
  // @ts-ignore-next-line
  window.ybug_settings = { id: 'k1xzpnnz85rkv71c8k5y' }
  const ybug = document.createElement('script')

  ybug.type = 'text/javascript'
  ybug.id = 'ybug-button-script'
  ybug.async = true
  // @ts-ignore-next-line
  ybug.src = 'https://widget.ybug.io/button/' + window.ybug_settings.id + '.js'

  document.head.appendChild(ybug)
}

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://ae35153a37f688e57a081024402d79dd@o4509038534656000.ingest.de.sentry.io/4509162664099920',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.browserProfilingIntegration()],
  tracePropagationTargets: ['localhost', import.meta.env.VITE_API_ROOT],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0
})

app
  .use(createPinia())
  .use(Toast, {
    position: POSITION.TOP_RIGHT,
    timeout: 10000
  })
  .use(router)
  .use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: true,
          staleTime: 1000 * 60 * 2
        }
      }
    }
  })
  .use(
    createAuth0({
      domain: import.meta.env.VITE_AUTH0_DOMAIN,
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE
      }
    })
  )
  .mount('#app')
